import { http } from '../utils/http';
import Seller from '../interfaces/output/seller';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';

export default class SellerApi {
    static fetchSellerById = async(sellerId: string): Promise<Seller> => {
        const { data } = await http.get<Seller>(`seller/${sellerId}`);

        return data;
    };

    static fetchSellers = async(paging: Paging): Promise<Pagination<Seller>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/seller');
        const { data } = await http.get<Pagination<Seller>>(url);

        return data;
    };

    static createSeller = async(seller: Seller): Promise<any> => {
        const newSeller = {
            name: seller?.name,
            ssoName: seller?.ssoName,
            userId: seller?.userId
        };

        const { data } = await http.post<any, Seller>('seller', newSeller);

        return data;
    }

    static updateSeller = async(seller: Seller): Promise<any> => {
        const newSeller = {
            name: seller?.name,
            ssoName: seller?.ssoName,
            userId: seller?.userId
        };

        const { data } = await http.put<any, Seller>(`seller/${seller.id}`, newSeller);

        return data;
    }

    static deleteSeller = async(sellerId: number): Promise<Seller> => {
        const { data } = await http.delete<Seller>(`seller/${sellerId}`);

        return data;
    }
}
